import { useEffect, useRef } from "react";
import axios from "axios";

export const isEmbedded = () => {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
};

const POLL_INTERVAL_MS = 2500;

// Polls until the mail link is approved (then goes to the start page, like the mail link does) or the pending login expires.
export default function EmbeddedLoginPoller({ pending, onLoggedIn = () => window.location.assign(window.location.origin + "/"), onExpired = () => {} }) {
    const done = useRef(false);

    useEffect(() => {
        done.current = false;

        const check = async () => {
            if (done.current) {
                return;
            }
            try {
                const { data } = await axios.get(window.location.origin + "/api/embed-login/status", {
                    params: { pending },
                });
                if (data.authenticated && !done.current) {
                    done.current = true;
                    onLoggedIn();
                }
            } catch (error) {
                if (error.response && error.response.status === 410 && !done.current) {
                    done.current = true;
                    onExpired();
                }
            }
        };

        const timer = setInterval(check, POLL_INTERVAL_MS);
        return () => {
            done.current = true;
            clearInterval(timer);
        };
    }, [pending]);

    return null;
}
